import classnames from "classnames";
import styles from "./RateCard.module.scss";

const RateCard = ({ className, approxRates, condition }) => {
  const { approxCustomerRate, approxDriverRate } = approxRates || {};

  return (
    <div
      className={classnames(className, styles.wrapper)}
      style={{ minHeight: condition ? "11rem" : "8.8rem" }}
    >
      <div className={styles.group}>
        <span className={styles.title}>
          {condition ? "AI customer rate" : "AI cust. rate"}
        </span>
        <p className={styles.value}>${approxCustomerRate}</p>
      </div>

      <div className={styles.group}>
        <span className={styles.title}>
          {condition ? "AI driver rate" : "AI driv. rate"}
        </span>
        <p className={styles.value}>${approxDriverRate}</p>
      </div>
    </div>
  );
};

export default RateCard;
